export default __webpack_public_path__ + "static/media/l2.0efd5614.jpg";